import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { FieldErrors, useForm } from 'react-hook-form';
import { validateCPFCNPJ } from '../../helpers/utils';

const productItemSchema = z
    .object({
        name: z
            .string()
            .min(1, { message: 'Campo obrigatório' })
            .refine(val => val.includes(' '), {
                message: 'Informe o nome completo',
            }),
        document: z.string().min(1, { message: 'Campo obrigatório' }),
        foreigner: z.boolean().optional().default(false),
    })
    .superRefine((data, ctx) => {
        if (!data.foreigner && !validateCPFCNPJ(data.document, true)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['document'],
                message: 'CPF inválido',
            });
        }
    });

const productSchema = z.object({
    products: z.array(productItemSchema),
});

type ProductSchemaType = z.infer<typeof productSchema>;
export type ProductErrorsType = FieldErrors<ProductSchemaType>;

export default function useFormProductLogic() {
    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors, isValid },
        trigger,
        setValue,
        watch,
        reset
    } = useForm<ProductSchemaType>({
        resolver: zodResolver(productSchema),
        mode: 'onBlur',
        defaultValues: {
            products: [
                { name: undefined, document: undefined, foreigner: false },
            ],
            // terms: false,
        },
    });

    return {
        register,
        handleSubmit,
        getValues,
        errors,
        isValid,
        trigger,
        setValue,
        watch,
        reset
    };
}
